import {
  AgentInfoWithAgencyResponse,
  AgentCustomLinkDetailsResponse,
} from '../../types';
import { AbstractClient } from './AbstractClient';

export class AgentClient extends AbstractClient {
  fetch = this.createGetHandler<
    AgentInfoWithAgencyResponse,
    { args: { slug: string } }
  >(({ slug }) => `/${slug}`, { include: 'agency' });

  getCustomLinkDetails = this.createGetHandler<
    AgentCustomLinkDetailsResponse,
    { args: { agentId: string; customLinkSlug: string } }
  >(
    ({ agentId, customLinkSlug }) =>
      `/${agentId}/custom-links/${customLinkSlug}`,
  );
}
